import InputField from 'components/Form/InputField';
import SelectField from 'components/Form/SelectField';
import SearchField from "components/Form/SearchField";
import RadioButtonGroup from "components/Form/Radio/RadioButtonGroup";
import MultiSelectField from "components/Form/MultiSelectField";
import CheckBox from "components/Form/CheckBox";

export default class FitFormTolls {

    verifyComponent(fieldId, questions) {
        if (!questions) return;
        const question = questions.find(
            (item) => item.idQuestion.toString() === fieldId
        );
        if (question) {
            let behaviors = JSON.parse(question.questionBehavior);

            if (question.questionDomain === 42) return InputField;
            if (question.questionDomain === 43) {
                if (behaviors && behaviors.isComponentRelated) {
                    switch (behaviors.componentId) {
                        case "RadioButton": return RadioButtonGroup;

                        case "CheckBox": return CheckBox;

                        default: return SelectField;
                    };
                };
                return SelectField;
            }
            if (question.questionDomain === 44) return MultiSelectField;
            if (question.questionDomain === 276) return SearchField;
            if (question.questionDomain === 295) return InputField;
            if (question.questionDomain === 277) return InputField;
        }
    };

    verifyOptions(fieldId, questions) {
        if (!questions) return;
        const field = questions.find((f) => f.idQuestion.toString() == fieldId);
        if (field) {
            if (field.answerOptions) return FitFormTolls.fieldRenderOptions(field.answerOptions);
            return null;
        }
        return [];
    };

    getDsQuestion(fieldId, questions) {
        if (!questions) return;
        const question = questions.find(
            (item) => item.idQuestion.toString() === fieldId
        );
        if (question) {
            return question.questionDescription ? question.questionDescription : "";
        }
    };

    verifyRequired(fieldId, questions) {
        if (!questions) return;
        const question = questions.find(
            (item) => item.idQuestion.toString() === fieldId
        );
        if (question) {
            if (question?.questionBehavior) {
                let behaviors = JSON.parse(question.questionBehavior);
                return behaviors.isRequired;
            }
        }
        return false;
    };

    verifyVisiblity = (fieldId, questions) => {
        if (!questions) return;
        const question = questions.find(
            (item) => item.idQuestion.toString() === fieldId
        );
        if (question) {
            if (question?.questionVisible)
                return question.questionVisible == 1 ? false : true;
            return true;
        }
        return true;
    };

    static fieldRenderOptions(answerOptions) {
        let result = [];
        answerOptions.forEach((element) => {
            result.push({
                label: element.answerOptionDescription,
                value: {
                    idAnswerOption: element.idAnswerOption,
                    dsAnswerOption: element.answerOptionDescription,
                },
            });
        });
        return result;
    };
}